export default __webpack_public_path__ + "static/media/icon-video-consult-white.038310d1.svg";